// @flow

import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import config from "@config";
import actionCreators from "@modules/shared/actionCreator";
import { GetSharedEmployeePositions } from "@modules/shared/constants/actions";

type EmployeePositionsRequest = $Exact<{
  clientId: string,
  employeeId: string,
  page?: number,
}>;

export function* onGetSharedEmployeePositions({
  payload,
}: Action<EmployeePositionsRequest>): Generator<*, void, Object> {
  if (!payload || !payload.clientId || !payload.employeeId) {
    throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
  }

  try {
    const response = yield call(
      http.get,
      `/api/v1/hierarchy-admin/client/${payload.clientId}/hierarchy/employee/${payload.employeeId}/employee-position`,
      {
        params: {
          limit: config.resultsPerPage,
          page: payload.page || 1,
        },
      },
    );

    yield put(actionCreators.GetSharedEmployeePositionsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetSharedEmployeePositionsError(e.response));
  }
}

export function* EmployeePositionsSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetSharedEmployeePositions, onGetSharedEmployeePositions)]);
}

export default EmployeePositionsSagas;
